import React from 'react';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { messages, parcelGuardMessages, xCoverMessages } from './messages';
import styles from './walleted-insurance.module.less';
import FormattedCurrency from '../../../../components/formatted-currency';
import { InsuranceProviders } from '../../../../enums/insurance-providers';
import { InsuranceTermsLink } from '../../../../insurance/terms-link';
import { EventSourceStrings } from '../../../../tracking/tracking-constants';
import { Text } from 'ui-components/components/text/text';
import { TextType } from 'ui-components/components/text/text-type';

/**
 * @param {object} props
 * @param {string} props.insuranceProviderId
 * @returns {React.ReactElement}
 */
export const WhyInsuranceCard = ({ insuranceProviderId }) => {
  const carrierMessages = insuranceProviderId === InsuranceProviders.XCover.insuranceProviderId ? xCoverMessages : parcelGuardMessages;

  return (
    <div className={styles['why-insurance-card']}>
      <Text className={styles['list-title']} textType={TextType.H4} value={carrierMessages.whyInsuranceTitle} />
      <ul>
        {insuranceProviderId === InsuranceProviders.XCover.insuranceProviderId ? (
          <>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listCheaper} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listFaster} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listCoverageTypes} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listCoveredCosts} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listFastPayout} />
            </li>
          </>
        ) : (
          <>
            <li>
              <FormattedCurrency fractionDigits={0} value={10000}>
                {(formattedBalance) => (
                  <Text
                    formattedMessageValues={{
                      amount: formattedBalance,
                    }}
                    textType={TextType.Paragraph}
                    value={messages.listCoverShipments}
                  />
                )}
              </FormattedCurrency>
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listClaims} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listInternationalCoverage} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.listPayBalance} />
            </li>
          </>
        )}
      </ul>
      <InsuranceTermsLink insuranceProviderId={insuranceProviderId} source={EventSourceStrings.INSURANCE_SETTINGS_CONTENT}>
        <Text element='span' textType={TextType.Paragraph} value={messages.listLearnMore} />
        <FontAwesomeIcon className={styles['external-link-icon']} icon={faArrowUpRightFromSquare} />
      </InsuranceTermsLink>
    </div>
  );
};
